var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"craigslist-account-edit"}},[_c('craigslist-account-form',{attrs:{"loading":_vm.loading},on:{"submit":_vm.updateAccount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }